import { useEffect, useRef } from 'react';

export default function useLocomotiveScroll(enabled = true) {
  const scrollRef = useRef(null);
  const locomotiveScrollRef = useRef(null);

  useEffect(() => {
    if (!enabled) return;

    let ScrollTrigger;
    
    const initScroll = async () => {
      try {
        // Dynamic imports
        const locomotiveModule = 'locomotive-scroll';
        const gsapModule = 'gsap';
        const stModule = 'gsap/ScrollTrigger';
        
        const LocomotiveScroll = (await import(/* @vite-ignore */ locomotiveModule)).default;
        const { gsap } = await import(/* @vite-ignore */ gsapModule);
        const { ScrollTrigger: ST } = await import(/* @vite-ignore */ stModule);
        
        ScrollTrigger = ST;
        gsap.registerPlugin(ScrollTrigger);

        // Initialize Locomotive Scroll
        locomotiveScrollRef.current = new LocomotiveScroll({
          el: document.querySelector('[data-scroll-container]'),
          smooth: true,
          multiplier: 0.8,
          lerp: 0.03,
          class: 'is-revealed',
          smartphone: {
            smooth: true,
            multiplier: 0.8
          },
          tablet: {
            smooth: true,
            multiplier: 0.8
          }
        });

        // Update ScrollTrigger on scroll
        locomotiveScrollRef.current.on('scroll', ScrollTrigger.update);

        // Setup ScrollTrigger proxy
        ScrollTrigger.scrollerProxy('[data-scroll-container]', {
          scrollTop(value) {
            return arguments.length
              ? locomotiveScrollRef.current.scrollTo(value, 0, 0)
              : locomotiveScrollRef.current.scroll.instance.scroll.y;
          },
          getBoundingClientRect() {
            return {
              top: 0,
              left: 0,
              width: window.innerWidth,
              height: window.innerHeight
            };
          },
          pinType: document.querySelector('[data-scroll-container]').style.transform
            ? 'transform'
            : 'fixed'
        });

        // Refresh on window resize
        const handleResize = () => {
          locomotiveScrollRef.current.update();
          ScrollTrigger.refresh();
        };
        
        window.addEventListener('resize', handleResize);

        // Initial refresh
        ScrollTrigger.refresh();

        return () => {
          window.removeEventListener('resize', handleResize);
          if (locomotiveScrollRef.current) {
            locomotiveScrollRef.current.destroy();
          }
          ScrollTrigger.killAll();
        };
      } catch (error) {
        console.log('Locomotive Scroll not installed yet');
      }
    };

    initScroll();

    return () => {
      if (locomotiveScrollRef.current) {
        locomotiveScrollRef.current.destroy();
      }
    };
  }, [enabled]);

  return locomotiveScrollRef.current;
}
